import {
  FlexColumn,
  useFormConfigurationContext,
} from '@equifinance/shared';
import styled from 'styled-components';
import moment from 'moment';
import { ChecklistSection } from '../../../../ChecklistPage';
import { PaddedGenericSection } from '../../../GenericSection';
import { useChecklistContext } from '../../../../../../contexts';
import { filesToChecklistDocuments } from '../../../../common/checklistDocument';
import DocumentItem from '../../../../components/DocumentItem';
import UploadDocuments from '../../../../../UploadDocuments';

const DocumentSectionContainer = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[5]};
`}`;

export default function ValuationDocumentsSection() {
  const { checklist, uploadChecklistDocuments } = useChecklistContext();
  const { valuation } = checklist ?? {};
  const { isDisabled } = useFormConfigurationContext();

  const uploadingFiles = async (files: File[]) => {
    const documents = await filesToChecklistDocuments(files);
    await uploadChecklistDocuments({
      documents,
      checklistSectionId: valuation?.id || '',
    });
  };

  const sortedDocumentsByDate = [...(valuation?.documents || [])].sort((d1, d2) => moment(d2.uploadedDate).diff(moment(d1.uploadedDate)));

  return (
    <PaddedGenericSection
      title="Documents"
      subSection={ChecklistSection.VALUATION_DOCUMENTS}
      level={1}
    >
      <DocumentSectionContainer>
        {sortedDocumentsByDate.map((document) => (
          <DocumentItem
            key={document.id}
            document={document}
          />
        ))}
        <UploadDocuments
          uploadingFiles={uploadingFiles}
          disabled={isDisabled}
        />
      </DocumentSectionContainer>
    </PaddedGenericSection>
  );
}
